import React, { useRef } from "react";
import ContactSection from "../common/ContactAs";
import Footer from "../common/Footer";
import NavigationBar from "../common/NavigationBar";
import HomeSection from "../components/HomeSection";
import AboutSection from "../components/AboutSection";
import WhyChooseSection from "../components/WhyChooseSection";
import OurServices from "../components/OurServices";
import OurPricing from "../components/OurPricing";
import TestiMonials from "../components/TestiMonials";
import NewsLetter from "../components/NewsLetter";
import GetInTouch from "../components/GetInTouch";
import InfoAccordion from "../components/LoanOffer/InfoAccordion";


const LandingPage = () => {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const offersRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <NavigationBar homeRef={homeRef} />

      <section ref={homeRef}>
          <HomeSection />
      </section>

      <section ref={servicesRef}>
        <OurServices />
      </section>

      <section>
        <OurPricing />
      </section>

      <section ref={aboutRef}>
        <AboutSection />
      </section>

      <section>
        <TestiMonials />
      </section>

      <section ref={offersRef}>
        <WhyChooseSection />
      </section>

      <section>
        <InfoAccordion />
      </section>

      <section>
        <NewsLetter />
      </section>

      {/* Contact */}
      <section>
        <GetInTouch />
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
